import React from 'react';
import { Plus } from '@phosphor-icons/react';
import { MOTION, EASE_IOS_CSS } from '../../../lib/immobilien/motion';
import { ImmoButton } from './Button';

/**
 * Drehkarte (README §4.8/§9): rotateY 0 → 180°, .75 s, perspective 1800px,
 * backface-visibility hidden. Vorne die Ansicht, hinten das Formular.
 * Die jeweils sichtbare Seite bestimmt die Höhe.
 */
export interface FlipCardProps {
  gedreht: boolean;
  vorne: React.ReactNode;
  hinten: React.ReactNode;
}

export function FlipCard({ gedreht, vorne, hinten }: FlipCardProps) {
  const seite: React.CSSProperties = {
    top: 0, left: 0, right: 0, backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden',
  };
  return (
    <div style={{ perspective: MOTION.flip.perspektivePx }}>
      <div
        style={{
          position: 'relative',
          transformStyle: 'preserve-3d',
          WebkitTransformStyle: 'preserve-3d',
          transition: `transform ${MOTION.flip.duration}s ${EASE_IOS_CSS}`,
          transform: gedreht ? 'rotateY(180deg)' : 'rotateY(0deg)',
        }}
      >
        <div
          aria-hidden={gedreht || undefined}
          inert={gedreht}
          style={{ ...seite, position: gedreht ? 'absolute' : 'relative', pointerEvents: gedreht ? 'none' : 'auto', overflow: gedreht ? 'hidden' : 'visible', height: gedreht ? '100%' : 'auto' }}
        >
          {vorne}
        </div>
        <div
          aria-hidden={!gedreht || undefined}
          inert={!gedreht}
          style={{
            ...seite,
            position: gedreht ? 'relative' : 'absolute',
            overflow: gedreht ? 'visible' : 'hidden',
            height: gedreht ? 'auto' : '100%',
            transform: 'rotateY(180deg)',
            pointerEvents: gedreht ? 'auto' : 'none',
          }}
        >
          {hinten}
        </div>
      </div>
    </div>
  );
}

/**
 * Kopf über einer Drehkarte: Titel 18/800 und Knopf, der zu „Abbrechen“ wechselt
 * (Plus dreht sich um 45°).
 */
export function FlipKopf({ titel, offen, label, onToggle, abbrechenLabel = 'Abbrechen' }: {
  titel: string;
  offen: boolean;
  /** Label im geschlossenen Zustand, z. B. „Beleg erfassen“. */
  label: string;
  onToggle: () => void;
  abbrechenLabel?: string;
}) {
  return (
    <div className="flex items-center justify-between flex-wrap" style={{ gap: 10 }}>
      <span style={{ fontSize: 18, fontWeight: 800, letterSpacing: '-0.01em' }}>{titel}</span>
      <ImmoButton art={offen ? 'fuellung' : 'akzent'} groesse={44} icon={Plus} iconGedreht={offen} onClick={onToggle} aria-expanded={offen}>
        {offen ? abbrechenLabel : label}
      </ImmoButton>
    </div>
  );
}
